import { Box } from "@mui/system";
import { ArrowBack, Delete, Save } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { HelperView } from "@my-helpers/common";
import Button from "@/components/Button";

const HelperControls = ({
    currentHelper,
    isHelperValid,
    handleSubmit,
    setCreating
}: {
    currentHelper?: HelperView;
    isHelperValid: boolean;
    handleSubmit: (action: 'create' | 'update' | 'delete') => void;
    setCreating?: (creating: boolean) => void;
}) => {
    const navigate = useNavigate();
    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-end',
            gap: 1,
            padding: '4px 0'
        }}>
            <Button
                variant="secondary"
                icon={<ArrowBack />}
                tooltip="Back to Helpers"
                onClick={() => {
                    navigate('/helpers');
                    if (setCreating) {
                        setCreating(false);
                    }
                }}
            />
            {
                currentHelper?.id ? (
                    <Button
                        variant="error"
                        icon={<Delete />}
                        tooltip="Delete Helper"
                        onClick={() => handleSubmit('delete')}
                    />
                ) : (
                    <Button
                        variant="primary"
                        icon={<Save />}
                        tooltip="Create Helper"
                        onClick={() => handleSubmit('create')}
                        disabled={!isHelperValid}
                    />
                )
            }
        </Box>
    )
}

export default HelperControls;